<template>
  <div id="home" @click="onHome">
    <Navbar></Navbar>
    <SideNavbar
      :searches="searches"
      @addNewSearch="onAddNewSearch"
      @addFilter="onAddFilter"
      @removeFilter="onRemoveFilter"
      @removeCategorie="onRemoveCategorie"
      @removeValue="onRemoveValue"
      @changeBusinessUnit="onChangeBusinessUnit"
      :businessUnits="businessUnits">
    </SideNavbar>
    <SelectFilter :show_filter="show_filter" v-show="show_filter" :businessUnit="businessUnit" @createFilter="onCreateFilter"></SelectFilter>
    <h1>{{$t('report')}}</h1>
    <div id="container-grid">
      <div id="grid" :class="'col-' + searches.length">
        <div class="search-container" v-for="search in searches" :key="search.rowId">
          <Results :reference="reference" :search="search" @removeSearch="onRemoveSearch" :nbOfColumns="searches.length" @updateResult="onUpdateResult"
                   @changeTopFamily="onChangeTopFamily"
                   @changeMetricFamily="onChangeMetricFamily"
                   @changeTopBrand="onChangeTopBrand"
                   @changeMetricBrand="onChangeMetricBrand"
                   :topFamily=topFamily
                   :metricFamily="metricFamily"
                   :topBrand=topBrand
                   :metricBrand=metricBrand>
          </Results>
        </div>
        <div id="add-column" v-show="searches.length < 3">
          <div class="btn-add" @click="onAddNewSearch">
            <div class="icon plus"></div>
          </div>
          <div class="btn-add" @click="onLoadQuery">
            <div class="icon search" ></div>
          </div>
        </div>
      </div>
    </div>
    <LoadQuery v-if='isLoadQueryModalVisible' @closeModal="onCloseModal" @addQuery="onAddQuery"></LoadQuery>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import SideNavbar from './components/SideNavbar.vue'
import SelectFilter from './components/SelectFilter.vue'
import Results from './components/Results.vue'
import LoadQuery from './components/LoadQuery.vue'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    Navbar, SideNavbar, SelectFilter,
    Results, LoadQuery
  },
  data() {
    return { 
      searches: [],
      show_filter: false,
      creating_filter_for: 0,
      closeGeneraleFilter: false,
      closeClientsFilter: false,
      rowCount: 0, 
      isLoadQueryModalVisible: false, 
      businessUnits: [],
      businessUnit: '',
      reference: {},
      results : [],
      topFamily: null,
      metricFamily: null,
      topBrand: null,
      metricBrand: null
    }
  },
  mounted() {
  },
  created(){
    axios.get(this.$store.state.user.url + '/profile', {headers: {'Authorization': 'Bearer ' + this.$store.state.user.token}})
      .then(response => {
        this.businessUnits = response.data.result.businessUnits
        const userBrands = response.data.result.brands
        const userFamilies = response.data.result.families
        let currenciesData =  {
          date: response.data.result.currencies.currencies.date,
          currenciesValues: {
            PLN: response.data.result.currencies.currencies.PLN,
            RON: response.data.result.currencies.currencies.RON,
            RUB: response.data.result.currencies.currencies.RUB,
            ARS: response.data.result.currencies.currencies.ARS
          }
        }
        this.$store.commit('setCurrencies', {currenciesData})
        this.$store.commit('setUserBrands', userBrands)
        this.$store.commit('setUserFamilies', userFamilies)
      })
      .catch(err => {
        console.error(err)
        localStorage.removeItem('jwtToken')
        this.$router.push(
          {name: 'login'}
        )
      })
  },
  methods: {
    onHome(event) {
      if(this.show_filter == true && event.target.className != "add-filter-anchor") {
        let findEventFilter = false
        var path = event.path || (event.composedPath && event.composedPath())
        path.forEach(function(element) {
          if(element.className == "select-filter") {
            findEventFilter = true
          }
        });
        if(findEventFilter == false) {
          this.show_filter = false
        }
      }
    },
    onChangeBusinessUnit(businessUnit) {
      this.businessUnit = businessUnit
    },
    onAddNewSearch() {
      if (this.searches.length < 3) {
        this.addQuery()
       }
    },
    onAddQuery(query, name, id){
      this.addQuery(query, name, id)
    },
    addQuery: function (query, name, id) {
      this.rowCount += 1
      let newQueryName = name || 'Query #' + (this.rowCount)
      let newQuery = query || {
        period: {
          startDate: null, 
          endDate:null
        },
        filters: [],
        businessUnit: this.businessUnits[0], 
        mode: "profile"

      }
      let newQueryId = id
      this.searches.push({
        title: newQueryName,
        query: newQuery,
        id: newQueryId,
        rowId: this.rowCount
      })
    },
    onLoadQuery(){
      this.isLoadQueryModalVisible = true
    },
    onCloseModal() {
      this.isLoadQueryModalVisible = false
    },
    onUpdateResult(event) {
      let index = this.searches.indexOf(event.search)
      if (index>=this.results.length) {
        this.results.push(event.result)
      }else{
        this.results[index] = event.result
      }
      if (index == 0) {
        this.reference.result = event.result
        this.reference.search = event.search
      }
    },
    onRemoveSearch(search) {
      for (let i = 0; i < this.searches.length; i++) {
        if (this.searches[i].rowId == search.rowId) {
          this.searches.splice(i, 1)
          this.results.splice(i, 1)
        }
      }
      if (this.results.length > 0) {
        this.reference.result = this.results[0]
        this.reference.search = this.searches[0]
      }else{
        this.reference.search = this.reference.result = {}
      }
    },
    onAddFilter(search_id) {
      this.show_filter = !this.show_filter
      this.creating_filter_for = search_id
    },
    onCreateFilter(general, clients) {
      for (let i = 0; i < this.searches.length; i++) {
        if (this.searches[i].rowId == this.creating_filter_for) {
          this.searches[i].query.filters.push({
            general: general,
            clients: clients,
            operator: true
          })
        }
      }
      this.show_filter = false
    },
    onRemoveFilter(search_id, findex) {
      for (let i = 0; i < this.searches.length; i++) {
        if (this.searches[i].rowId == search_id) {
          this.searches[i].query.filters.splice(findex, 1)
        }
      }
    },
    onRemoveCategorie(search_id, type, findex, cindex) {
      for (let i = 0; i < this.searches.length; i++) {
        if (this.searches[i].rowId == search_id) {
          if(type == "general") {
            let still_show = false
            this.searches[i].query.filters[findex].general[cindex].value = false
            for(let index in this.searches[i].query.filters[findex].general) {
              if (this.searches[i].query.filters[findex].general[index].value) still_show = true
            }
            if (!still_show) {
              this.closeGeneraleFilter = true
            }
          } else {
            let still_show_client = false
            this.searches[i].query.filters[findex].clients[cindex].value = false
            for(let index in this.searches[i].query.filters[findex].clients) {
              if (this.searches[i].query.filters[findex].clients[index].value) still_show_client = true
            }
            if (!still_show_client) {
              this.closeClientsFilter = true
            }
          }
        }
      }
      if (this.closeClientsFilter && this.closeGeneraleFilter) {
        this.onRemoveFilter(search_id, findex)
        this.closeClientsFilter = false
        this.closeGeneraleFilter = false
      }
    },
    onRemoveValue(search_id, type, findex, cindex, iindex) {
      for (let i = 0; i < this.searches.length; i++) {
        if (this.searches[i].rowId == search_id) {
          let currentFilter = this.searches[i].query.filters[findex];
          if(type == "general") {
            let currentIndex = currentFilter.general[cindex];
            currentIndex.filtersArray[iindex].value = false
            let still_show = false
            for(let index in currentIndex.filtersArray) {
              if (currentIndex.filtersArray[index].value) still_show = true
            }
            if (!still_show) {
              this.onRemoveCategorie(search_id, type, findex, cindex)
            }

          } else {
            let current = currentFilter.clients[cindex];
            let array = current.filters ? current.filters :current.filtersArray

            array[iindex].value = false
            let still_show_client = false
            for(let index in array) {
              if (array[index].value) still_show_client = true
            }
            if (!still_show_client) {
              this.onRemoveCategorie(search_id, type, findex, cindex)
            }
          }
        }
      }
    },
    onChangeTopFamily(event) {
      this.topFamily = event
    },
    onChangeMetricFamily(event) {
      this.metricFamily = event
    },
    onChangeTopBrand(event) {
      this.topBrand = event
    },
    onChangeMetricBrand(event) {
      this.metricBrand = event
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/home.sass"
</style>
